import { render, staticRenderFns } from "./Rule61ResponseInstructions.vue?vue&type=template&id=3d00b168&scoped=true"
import script from "./Rule61ResponseInstructions.vue?vue&type=script&lang=ts"
export * from "./Rule61ResponseInstructions.vue?vue&type=script&lang=ts"
import style0 from "./Rule61ResponseInstructions.vue?vue&type=style&index=0&id=3d00b168&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d00b168",
  null
  
)

export default component.exports